import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface Alert {
  alertID: string;
  createdDateLocal: string;
  createdDate: string;
  closedDateLocal: string;
  topic: string;
  status: string;
  owner: string;
  integration: string;
  closedDate: string;
  resolution: string;
}

interface AlertResponse {
  alerts: Array<Alert>;
  assignedCount: string;
  closedCount: string;
  openCount: string;
}

class AlertService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt
      }
    });
  }
  async getAlerts(): Promise<AxiosResponse<AlertResponse>> {
    return await this.client.get("/alerts");
  }
  async getAlertsByDate(startdate: string, enddate: string): Promise<AxiosResponse<AlertResponse>> {
    return await this.client.get(`/alerts?startdate=${startdate}&enddate=${enddate}`);
  }
}

export default AlertService;
